export default "__VITE_PUBLIC_ASSET__afc0d8da__"